/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faFilePdf, faTrash, faBan, faPrint, faEdit, faEye,faCopy,faSpinner} from '@fortawesome/free-solid-svg-icons'
import { faEnvelopeOpen } from '@fortawesome/free-regular-svg-icons'
import { Link } from 'react-router-dom'
import func, { translateLabel } from '../../services/functions'
import invoiceTypes from '../../services/InvoiceTypes.json'
import { getStore, useAppContext } from '../../AppContext'
import CellInput from '../global/CellInput'
import profileIDS from "../../services/profileIDS.json"
import { Menu } from "primereact/menu";
import { paymentOptions } from '../../services/data'
import LoadingLayover from '../global/LoadingLayover'
import { buyerIDTypesSelectOptions } from './WizardSteps/data'
import { de } from 'date-fns/locale'


const bigDecimal = require("js-big-decimal")
const moment = require("moment")
const { bodyNumber } = func

const generateCustomInvoiceColumns = (
{
    showInvoicePdf,
    loadingPdf,
    toggleDeleteInvoice,
    handleInvoiceCancel,
    t,
    handleThermalPrint,
    isPos,
    invoiceTypeOptions,
    spinLoading,
    isRefreshStatus,
    myinvoiceTypes,
    handleDuplicateInvoice,
    i18n
}) => {

    const { user: [user], company: [fullCompany] } = getStore()
    const isViewRole = user.role.id === 7
    const userCanDelete = [1, 2, 15].includes(user.role.id) && !isViewRole
    const userCanCancel = [1, 2, 15].includes(user.role.id) && !isViewRole
    const userCanDuplicate = !isViewRole
    const profileIdOptions = profileIDS.map((profId) => ({ ...profId, label: t([profId.label]) }))


    return [
        {
            header: t(['invoice.nr']),
            style: { minWidth: "200px", maxWidth: "300px" },
            field: 'number',
            persisted: true,
            format: (invoice) => func?.preventExcelFormatFn(invoice?.number || ""),
            filter: true,
            sortable: true,
            default: true,
            mobile: { priority: 1, group: "identity" },

        },
        {
            header: t(["home.status"]),
            field: 'status',
            filter: true,
            style: { minWidth: "150px", maxWidth: "300px" },
            persisted:true,
            default:true,
            mobile: { priority: 1, isBadge: true, group: "status" },
            body: invoice => {
                let badgeClass = "secondary"
                let statusLabel = "Draft"

                let invoiceStatus = invoice.status.status
                if(isRefreshStatus(invoice)){
                    badgeClass = "warning"
                    statusLabel = t("status.pending")
                }
                else if(invoiceStatus==="READY_FOR_APPROVAL"){
                    badgeClass = "info"
                    statusLabel =  t("status.readyForApproval")
                }else if(invoiceStatus==="APPROVED"){
                    badgeClass = "success"
                    statusLabel = t("status.approved")
                }else if(invoiceStatus==="ERROR"){
                    badgeClass = "danger"
                    statusLabel = "Error"
                }else if(invoiceStatus==="DELETED"){
                    badgeClass = "danger"
                    statusLabel = "Deleted"
                }

                if (statusLabel === "Error") return (
                    <h4 className="mb-0"><span className={"badge badge-" + badgeClass}>{statusLabel}</span></h4>
                )

                else return (

                    <h4 className="mb-0"><span className={"badge badge-" + badgeClass}>{statusLabel}</span></h4>
                )
            },
            format:invoice=>{
                if(isRefreshStatus(invoice)){
                    return t("status.pending")
                }
                return invoice?.status?.status ?? ""
            }
        },
        {
            header: t(["invoice.print"]),
            field: 'print',
            style: { minWidth: "150px", maxWidth: "300px" },
            mobile: { priority: "action", group: "actions" },
            body: invoice => {
                const isLoadingPdf=loadingPdf?.id==invoice?.id && loadingPdf?.loading
                return <div className='d-flex align-items-center'>

                    {invoice.iic &&
                        <a
                            href="#"
                            className={"nav-link p-0 d-flex-align-items-center mr-1"}
                            onClick={(e) => { e.preventDefault(); handleThermalPrint(invoice.id) }}>
                            <img src="https://profisc.al/wp-content/uploads/2021/10/kupon.svg" title={t('invoice.printThermal')}  width="38" height="32"  />
                        </a>}
                    {invoice.iic &&
                        <a
                            href="#"
                            id={invoice.iic}
                            className={"nav-link p-0 d-flex-align-items-center mr-1"}
                            onClick={(e) =>  showInvoicePdf({key:'iic', invoice,e}) }>
                             <LoadingLayover loading={(isLoadingPdf && (loadingPdf?.key==="iic")) }>
                                <img src="https://profisc.al/wp-content/uploads/2021/10/Asset-11.svg" title={t('invoice.printFisc')} width="38" height="32" />
                            </LoadingLayover>
                        
                        </a>}
                    {invoice.eic &&
                        <a
                            href="#"
                            className={"nav-link p-0 d-flex-align-items-center mx-1"}
                            onClick={(e) =>  showInvoicePdf({key:'eic', invoice,e}) }>
                             <LoadingLayover loading={(isLoadingPdf && (loadingPdf?.key==="eic")) }>
                            < img src="https://profisc.al/wp-content/uploads/2021/10/Asset-12.svg" title={t('invoice.electronicInv')}  width="38" height="32" />
                            </LoadingLayover>

                        </a>}
                    {invoice.status.id == 7 || invoice.status.id == 8 ?
                        <a
                            href="#"
                            className={"nav-link p-0 d-flex-align-items-center mx-1"}
                            onClick={(e) => showInvoicePdf({key:'id', invoice,e})}>
                             <LoadingLayover loading={(isLoadingPdf && (loadingPdf?.key==="id")) }>
                                <img src="https://profisc.al/wp-content/uploads/2023/08/PrintfiscDraft.png" title={t('invoice.printFisc')} width="26" height="30" />
                             </LoadingLayover>
                        
                        </a>
                        : null}

                </div>
            },
            default:true,
            persisted:true
        },
                {
            header: t(['home.actions']),
            field: 'actions',
            style: { minWidth: "300px", maxWidth: "300px" },
            mobile: { priority: "action", group: "actions" },
            body: invoice => (
                <div className='d-flex align-items-center'>
                    <Link
                        to={`/${isPos?"pos-transactions/edit":"edit-invoice"}/${invoice.id}`}
                        style={{color:"#0275d8"}}
                        className={"nav-link p-0 d-flex align-items-center mr-2"}>
                        <FontAwesomeIcon icon={invoice.status.id === 9 || isViewRole ? faEye : faEdit} className="mx-1" />
                        {invoice.status.id === 9 || isViewRole ? t('common.view') : t('common.edit')}
                    </Link>


                    {(invoice.status.id === 7 && userCanDelete) &&
                        <a
                            href="#"
                            className="nav-link p-0 d-flex align-items-center text-danger ml-1"
                            onClick={e => toggleDeleteInvoice(e, invoice)}>
                            <FontAwesomeIcon icon={faTrash} className="mr-1" />
                            {t('common.delete')}

                        </a>}
                    {(invoice.status.id === 9 && userCanCancel) &&
                        <a
                            href="#"
                            className="nav-link p-0 d-flex align-items-center text-danger "
                            onClick={e => handleInvoiceCancel(e, invoice)}>
                            <FontAwesomeIcon icon={faBan} className="mr-1" />
                            {t('common.cancel')}

                        </a>
                        }
                            {invoice.status.status != 'ERROR' && userCanDuplicate && <a
                            href="#"
                            className={`${spinLoading?"disabled":"" } nav-link p-0 d-flex align-items-center ml-2`}
                            onClick={(e)=> handleDuplicateInvoice(e,invoice)}>
                              <FontAwesomeIcon className="mr-1" icon={faCopy} />
                            {t("invoice.duplicate")}
                        </a>}
                </div>
            ),
            default: true,
            persisted: true,
        },
        {
            header: t(['table.issueDatetime']),
            field: 'issueDate',
            style: { minWidth: "180px", maxWidth: "300px" },
            sortable: true,
            filter: true,
            filterType: "DATE",
            filterConfig: {
                like: false,
            },
            default: true,
            persisted: true,
            formattedExportValue: true,
            preventExcelFormat: true,
            body: invoice => invoice.issueDate ? moment(invoice.issueDate).format("DD/MM/YYYY HH:mm") : "",
            mobile: { priority: 1, group: "dates" },
        },
        {
            header: t(['table.recordDate']),
            field: 'recordDate',
            style: { minWidth: "200px", maxWidth: "300px" },
            filter: true,
            sortable: true,
            filterType: "DATE",
            filterConfig: {
                like: false,
                field:'invoiceDate'
            },
            formattedExportValue: true,
            preventExcelFormat: true,
            body: (invoice) =>
            invoice.recordDate
                ? moment(invoice.recordDate).format("DD/MM/YYYY HH:mm:ss")
                : "",
            mobile: { priority: 2 },
        },
        {
            field: "buyerIdType",
            header: t(["table.buyerIDType"]),
            filter: true,
            default: true,
            persisted: true,
            filterType: "DROPDOWN",
            filterConfig:{
                options:buyerIDTypesSelectOptions(t),
                placeholder:t(["table.buyerIDType"]),
                resetLabel:t(["table.buyerIDType"])
            },
            body:(row)=>row.buyerIdType==="empty"?"":row.buyerIdType,
            formattedExportValue:true,
            style: { minWidth: 180, maxWidth: 180 },
            mobile: { priority: 2 },
        },
        {
            header: t(['table.buyerNIPT']),
            style: { minWidth: "200px", maxWidth: "300px" },
            field: "buyerNipt",
            filter: true,
            default: true,
            filterConfig: {
                field: "buyerNipt",
                like: false
            },
            persisted: true,
            body: invoice => invoice?.parties?.buyer?.tin || "",
            formattedExportValue: true,
            mobile: { priority: 2 },
        },
        {
            header: t(["home.buyerName"]),
            style: { minWidth: "250px", maxWidth: "300px" },
            field: 'customer',
            filter: true,
            default: true,
            filterConfig:{
                field:"buyerName",
                like:false
            },
            persisted: true,
            formattedExportValue: true,
            body: invoice => invoice?.parties?.buyer?.name || "",
            mobile: { priority: 1, isTitle: true, group: "identity" },
        },
                {
            header: "Email",
            field: 'sendEmail',
            style: { minWidth: "50px", maxWidth: "300px" },
            body: invoice => (
                <>
                    {invoice.iic &&
                        <FontAwesomeIcon
                            icon={faEnvelopeOpen}
                            size={'2x'}
                            className={`ml-2`}// ${loadingPdf ? "text-secondary" : "text-primary"}`}
                            style={{ cursor: "pointer", height: '25px'}}
                            color={"#6fc483"}
                            onClick={() => func.sendEmailPdf(invoice.iic, invoice.customer, invoice?.parties?.buyer?.tin, t)}
                            title={t('email.sendByEmail')}
                        />
                    }
                </>
            ),
            mobile: { priority: "action", group: "actions" },
        },
        {
            header: t(['invoice.profileId']),
            style: { minWidth: "200px", maxWidth: "300px" },
            field: 'profileId',
            filter: true,
            filterType:"MULTISELECT",
            filterConfig:{
                like:false,
                options: profileIdOptions
            },
            mobile: { priority: 3 },
        },
        {
            header: t("customers.type"),
            style: { minWidth: "200px", maxWidth: "300px" },
            field: "type",
            body: invoice => invoice.type ? t([invoiceTypes.find(invoiceType => invoiceType.value === invoice.type)?.label??""]) : "",
            filter: true,
            default: true,
            persisted: true,
            filterType:"MULTISELECT",
            filterConfig:{
                options: invoiceTypeOptions,
                like:false
            },
            mobile: { priority: 2 },
        },
        {
            header: t("table.sellerNIPT"),
            style: { minWidth: "200px", maxWidth: "300px" },
            field: "sellerNipt",
            filter: true,
            body: invoice => invoice?.parties?.seller?.tin || "",
            formattedExportValue:true,
            mobile: { priority: 3 },
        },
        {
            header: t(['invoice.seller']),
            style: { minWidth: "200px", maxWidth: "300px" },
            field: 'seller',
            filterConfig:{
                field:"sellerName",
                like:false
            },
            filter:true,
            body: invoice => invoice.parties.seller?.name ? invoice.parties.seller.name : "",
            formattedExportValue: true,
            mobile: { priority: 3 },
        },
        {
            header: "Cash/NonCash",
            style: { minWidth: "230px", maxWidth: "300px" },
            field: 'paymentMethodType',
            filter:true,
            default:true,
            persisted:true,
            filterType:"DROPDOWN",
            filterConfig:{
              options: paymentOptions,
              like:false
            },
            body: invoice => invoice.paymentMethodType.toUpperCase() ?? "",
            mobile: { priority: 2 },
        },
        {
            header: t("invoice.rev/Self/Debt/Summary"),
            field: 'invoiceRevBad',
            style: { minWidth: "150px", maxWidth: "220px" },
            formattedExportValue: true,
            filter:true,
            filterType:"DROPDOWN",
            filterConfig:{
                options:myinvoiceTypes,
            },
            body: invoice => {
                if (invoice.badDebtInv) return t("books.badDebt")
                else if (invoice.reverseCharge) return t("books.reverse")
                else if (invoice.selfInvoice) return t("invoice.selfInvoice")
                else if (invoice.sumInv) return t("invoice.summaryInvoice")
                else return t(['vat.none'])
            },
            mobile: { priority: 3 },
        },
        {
            field: 'internalId',
            header: fullCompany?.companyAttributes?.find(a => a?.attribute?.param == "internalId")?.value ?? "ERP ID",
            style: { minWidth: "200px", maxWidth: "300px" },
            filterConfig:{
                like:false
              },
            filter: true,
            sortable: true,
            body: (invoice) => <CellInput value={invoice?.internalId ?? ""} width={220} onFocus={(event) => event.target.select()} />,
            mobile: { priority: 2 },
        },
        {

            header: t("invoice.IIC"),
            style: { minWidth: "200px", maxWidth: "300px" },
            field: 'iic',
            default: true,
            persisted: true,
            filter:true,
            body: (invoice) => <CellInput value={invoice?.iic ?? ""} width={220} onFocus={(event) => event.target.select()} />,
            mobile: { priority: 2, group: "reference" },
        },
        {
            header: t("invoice.FIC"),
            style: { minWidth: "200px", maxWidth: "300px" },
            field: 'fic',
            filter:true,
            default: true,
            persisted:true,
            body: (invoice) => <CellInput value={invoice?.fic ?? ""} width={220} onFocus={(event) => event.target.select()} />,
            mobile: { priority: 2, group: "reference" },
        },
        {

            header: "EIC",
            style: { minWidth: "200px", maxWidth: "300px" },
            field: 'eic',
            filter: true,
            body: (invoice) => <CellInput value={invoice?.eic ?? ""} width={220} onFocus={(event) => event.target.select()} />,
            mobile: { priority: 2, group: "reference" },
        },
        {
            header: t(['invoice.businessUnit']),
            style: { minWidth: "200px", maxWidth: "300px" },
            field: 'businessUnitCode',
            filter: true,
            default: true,
            persisted: true,
            mobile: { priority: 3 },
        },
        {
            header: t(['invoice.TcrCode']),
           style: { minWidth: "200px", maxWidth: "300px" },
            field: 'tcrCode',
            filter:true,
            default:true,
            persisted:true,
            mobile: { priority: 3 },
        },
        {
            header: t(['invoice.currency']),
            style: { minWidth: "200px", maxWidth: "300px" },
            field: 'currency',
            default: true,
            persisted: true,
            mobile: { priority: 3 },
        },
        {
            header: t(["hints.itemtotalWithoutVat"]),
            field: "invoiceTotalWithoutVat",
            style: { minWidth: "280px", maxWidth: "300px" },
            sortable: true,
            default: true,
            persisted: true,
            align: "right",
            body: (invoice) => func.getFormattedMoneyValue(invoice?.invoiceTotalWithoutVat),
            mobile: { priority: 2 },
        },
        {
            header: t(["books.vatAmount"]),
            field: "invoiceTotalVat",
            style: { minWidth: "280px", maxWidth: "300px" },
            sortable: true,
            default: true,
            persisted: true,
            align: "right",
            body: (invoice) => func.getFormattedMoneyValue(invoice?.invoiceTotalVat),
            mobile: { priority: 2 },
        },
        {
            header: t(["hints.itemtotalWithVat"]),
            style: { minWidth: "200px", maxWidth: "300px" },
            field: 'invoiceTotalWithVat',
            sortable: true,
            default: true,
            persisted: true,
            align: "right",
            body: invoice => func.getFormattedMoneyValue(invoice?.invoiceTotalWithVat),
            mobile: { priority: 2 },
        },
        {
            header: t(["invoice.feesTotal"]),
            style: { minWidth: "200px", maxWidth: "200px" },
            field: 'invoiceFeesTotal',
            sortable: true,
            default: true,
            persisted: true,
            align: "right",
            body: invoice => func.getFormattedMoneyValue(invoice?.invoiceFeesTotal),
            mobile: { priority: 3 },
        },
        {
            header: t("invoice.totalPay"),
            field: 'invoiceTotalVirtualCol',
            sortable: true,
            align: "right",
            default: true, 
            persisted: true,
            style: { minWidth: "200px", maxWidth: "300px" },
            body:(invoice)=> func.getFormattedMoneyValue(bigDecimal.add((invoice?.invoiceTotalWithVat ?? "0"),(invoice?.invoiceFeesTotal ?? "0"))),
            format:(invoice)=> bigDecimal.add((invoice?.invoiceTotalWithVat ?? "0"),(invoice?.invoiceFeesTotal ?? "0")),
            mobile: { priority: 1, group: "financial" },
        },
        {
            header: "Total ALL",
            field: 'invoiceTotalWithVatALL',
            sortable: true,
            align: "right",
            default: true,
            persisted: true,
            style: { minWidth: "200px", maxWidth: "300px" },
            body: invoice => {
                const total = bigDecimal.add((invoice?.invoiceTotalWithVat ?? "0"), (invoice?.invoiceFeesTotal ?? "0"))
                return invoice.currency !== "ALL" ? func.getFormattedMoneyValue(bigDecimal.multiply(invoice.rate, total)) : ""
            },
            format: invoice => {
                const total = bigDecimal.add((invoice?.invoiceTotalWithVat ?? "0"), (invoice?.invoiceFeesTotal ?? "0"))
                return invoice.currency !== "ALL" ? bigDecimal.multiply(invoice.rate, total) : ""
            },
            mobile: { priority: 3 },
        },
        {
            header: t(["home.exchangeRate"]),
            field: "rate",
            default: true,
            persisted: true,
            style: { minWidth: "150px", maxWidth: "300px" },
            body: (invoice) =>
            invoice.rate !== "ALL" ?  invoice.rate : "",
            mobile: { priority: 3 },
        },
        {
            header: t("table.dueDate"),
            field: 'dueDate',
            style: { minWidth: "200px", maxWidth: "300px" },
            formattedExportValue: true,
            preventExcelFormat: true,
            body: (invoice) =>
            invoice.dueDate
                ? moment(invoice.dueDate).format("DD/MM/YYYY HH:mm:ss")
                : "",
            filter:true,
            sortable: true,
            filterType: "DATE",
            filterConfig: {
                like: false
            },
            mobile: { priority: 3 },
        },
        {
            header: t("openBanking.paymentStatus"),
            field: "internalPaymentStatus",
            filter: true,
            style: { minWidth: 200, maxWidth: 300 },
            body: (payment) => {
                return translateLabel(payment?.internalPaymentStatus?.engName, payment?.internalPaymentStatus?.albName, i18n)
            },
            mobile: { priority: 3 },
        },
                {
            header: t(['common.username']),
            style: { minWidth: "200px", maxWidth: "300px" },
            field: "recordUser",
            filter: true,
            default: true,
            persisted: true,
            mobile: { priority: 3 },
        },
        {
            header: t("invoice.Operator"),
            style: { minWidth: "200px", maxWidth: "300px" },
            field: "opCode",
            filter: true,
            default: true,
            persisted: true,
            mobile: { priority: 3 },
        },
        {

            header: fullCompany?.companyAttributes?.find(a => a?.attribute?.param == "AdditionalId1")?.value ?? (t("pos.additional") + " 1"),
            style: { minWidth: "200px", maxWidth: "300px" },
            field: 'param1',
            filterConfig:{
                like:false
            },
            filter: true,
            body: (row)=><CellInput value={row?.param1} width={150}/>,
            mobile: { priority: 3 },
        },
        {

            header: fullCompany?.companyAttributes?.find(a => a?.attribute?.param == "AdditionalId2")?.value ?? (t("pos.additional") + " 2"),
            style: { minWidth: "200px", maxWidth: "300px" },
            field: 'param2',
            filterConfig:{
                like:false
            },
            filter: true,
            body: (row)=> <CellInput value={row?.param2} width={150} />,
            mobile: { priority: 3 },
        },
        {
            field: "projectReference",
            header: t("invoiceReferenceFields.projectReference"),
            style: { minWidth: 220, maxWidth: 300 },
            body: (invoice) => invoice?.projectReference || "",
            filter: true,
            mobile: { priority: 3 },
        },
        {
            field: "contractReference",
            header: t("invoiceReferenceFields.contractReference"),
            style: { minWidth: 220, maxWidth: 300 },
            body: (invoice) => invoice?.contractReference || "",
            filter: true,
            mobile: { priority: 3 },
        },
        {
            field: "buyerReference",
            header: t("invoiceReferenceFields.buyerReference"),
            style: { minWidth: 220, maxWidth: 300 },
            body: (invoice) => invoice?.buyerReference || "",
            filter: true,
            mobile: { priority: 3 },
        },
        {
            field: "purchaseOrderReference",
            header: t("invoiceReferenceFields.purchaseOrderReference"),
            style: { minWidth: 220, maxWidth: 300 },
            body: (invoice) => invoice?.purchaseOrderReference || "",
            filter: true,
            mobile: { priority: 3 },
        },
        {
            field: "salesOrderReference",
            header: t("invoiceReferenceFields.salesOrderReference"),
            style: { minWidth: 220, maxWidth: 300 },
            body: (invoice) => invoice?.salesOrderReference || "",
            filter: true,
            mobile: { priority: 3 },
        },
        {
            field: "requestForBidReference",
            header: t("invoiceReferenceFields.requestForBidReference"),
            style: { minWidth: 240, maxWidth: 300 },
            body: (invoice) => invoice?.requestForBidReference || "",
            filter: true,
            mobile: { priority: 3 },
        },
        {
            field: "despatchNoteReference",
            header: t("invoiceReferenceFields.despatchNoteReference"),
            style: { minWidth: 220, maxWidth: 300 },
            body: (invoice) => invoice?.despatchNoteReference || "",
            filter: true,
            mobile: { priority: 3 },
        },
        {
            field: "schemaIdentifier",
            header: t("invoiceReferenceFields.schemaIdentifier"),
            style: { minWidth: 240, maxWidth: 300 },
            body: (invoice) => invoice?.schemaIdentifier || "",
            filter: true,
            mobile: { priority: 3 },
        },
        {
            field: "receiptReference",
            header: t("invoiceReferenceFields.receiptReference"),
            style: { minWidth: 240, maxWidth: 300 },
            body: (invoice) => invoice?.receiptReference || "",
            filter: true,
            mobile: { priority: 3 },
        },
    ];
}


export default generateCustomInvoiceColumns
